import { AWS_CONFIG_TYPE, PROFILE_ENV } from '../BaseUrl';

export const SESSION_USER = {
  name: `${JSON.parse(sessionStorage.getItem('user'))}`,
};

export const SEPRATOR = {
  // aws: __
  // azure: --
  value: AWS_CONFIG_TYPE ? '__' : '--',
};

export const CONNECTORS = {
  postgresql: `postgresql`,
  snowflake: `snowflake`,
  adls: `adls`,
  oracle: `oracle`,
  sqlserver: `sqlserver`,
  s3: `s3`,
};

export function updatedSecretName(connector, secret_name) {
  // example : dev__depadmin__postgresql__pg123

  return `${PROFILE_ENV}${SEPRATOR.value}${JSON.parse(sessionStorage.getItem('user'))}${SEPRATOR.value}${
    CONNECTORS[connector]
  }${SEPRATOR.value}${secret_name}`;
}
